import { Box, Stack, Tooltip } from "@mantine/core";
import { UseNavigateResult } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { type NavEntry } from "~/utils/navManifest";

import { optimisePageTitle } from "../../utils/Helper";
import RoundIconButton from "../Button/RoundIconButton";
import SvgIcon from "../SvgIcon";

const SidebarItem = ({
  entry,
  isActive,
  navigate,
}: {
  entry: NavEntry;
  isActive: boolean;
  navigate: UseNavigateResult<string>;
}) => {
  const { t } = useTranslation("common");
  const translatedName = t(`sectionNames.${entry.sectionName}`);
  const optimizedTitle = optimisePageTitle(translatedName);
  return (
    <Stack align="center">
      <Tooltip label={optimizedTitle} withArrow position="right">
        <Box>
          <RoundIconButton
            size={48}
            style={{
              backgroundColor: isActive
                ? "var(--mantine-color-bg-quarterary)"
                : undefined,
            }}
            onClick={() => void navigate({ to: entry.to })}
            role="menuitem"
            aria-label={optimizedTitle}
            aria-current={isActive ? "page" : undefined}
          >
            <SvgIcon name={entry.icon} aria-hidden="true" />
          </RoundIconButton>
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default SidebarItem;
